var BASE_DOMAIN_KEY = 'domain';
var domainKeys = {
  allDomains: [BASE_DOMAIN_KEY],
  domainsList: function domainsList(query) {
    return [BASE_DOMAIN_KEY, 'status', query];
  }
};
export default domainKeys;